// extracted by mini-css-extract-plugin
export default {"setting-container":"touchSelect_setting-container__HentF","setting":"touchSelect_setting__PpCPT"};